// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "./bootstrap-datepicker"
import "./custom-datepicker"
import "./main"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

window.addSeniorContactFields = function(link, association, content) {
    var new_id = new Date().getTime();
    var regexp = new RegExp("new_" + association, "g");
    $('#senior-contacts').append(content.replace(regexp, new_id));
}
